function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
  fill: "#B8E1F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 6C6.75 6.6875 7.3125 7.25 8 7.25C8.6875 7.25 9.25 6.6875 9.25 6C9.25 5.3125 8.6875 4.75 8 4.75C7.3125 4.75 6.75 5.3125 6.75 6ZM10 6C10 7.10938 9.10938 8 8 8C6.89062 8 6 7.10938 6 6C6 4.89062 6.89062 4 8 4C9.10938 4 10 4.89062 10 6ZM5.25 11.5V11.625C5.25 11.8281 5.07812 12 4.875 12C4.67188 12 4.5 11.8281 4.5 11.625V11.5C4.5 9.98438 5.73438 8.75 7.25 8.75H8.75C10.2656 8.75 11.5 9.98438 11.5 11.5V11.625C11.5 11.8281 11.3281 12 11.125 12C10.9219 12 10.75 11.8281 10.75 11.625V11.5C10.75 10.3906 9.85938 9.5 8.75 9.5H7.25C6.14062 9.5 5.25 10.3906 5.25 11.5Z",
  fill: "#006CA3"
});

function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.42a8767c.svg";
export { ForwardRef as ReactComponent };